// @flow
import Database from './Database'

const db: Database = new Database()

export default db


